/* eslint-disable jsx-a11y/no-noninteractive-element-interactions,jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useRef, useState } from 'react';
import _isEmpty from 'lodash/isEmpty';
import _isFunction from 'lodash/isFunction';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useIterateModifiers from '@/hooks/useIterateModifiers';
import { initTabs } from '@/utils/Controllers/TabsController';

const Tabs = ({ tabs, onClick, modifiers, activeAttribute, hasUpdateLine }) => {
  const { t } = useTranslation();
  const [lineStyle, setLineStyle] = useState({});
  const refs = useRef(tabs.map(() => React.createRef()));
  const modifiersString = useIterateModifiers('dln-tabs--', modifiers);

  const updateLine = () => {
    let finalIndex = -1;
    Array.from(tabs).forEach((tab, index) => {
      if (tab[activeAttribute]) finalIndex = index;
    });
    if (finalIndex > -1) {
      setLineStyle({
        width: `${refs.current[finalIndex].current.offsetWidth}px`,
        transform: `translateX(${refs.current[finalIndex].current.offsetLeft}px`,
      });
    }
  };

  useEffect(() => {
    initTabs();
    window.addEventListener('resize', initTabs);
    return () => {
      window.removeEventListener('resize', initTabs);
    };
  }, []);

  useEffect(() => {
    if (hasUpdateLine && !_isEmpty(tabs)) {
      updateLine();
    }
  }, [tabs]);

  const handleClick = tab => {
    if (!tab[activeAttribute] && _isFunction(onClick)) onClick(tab);
  };

  return (
    <div className={`dln-tabs ${modifiersString}`}>
      <span className='dln-tabs__gradient -left' />
      <span className='dln-tabs__gradient -right' />
      <ul className='dln-tabs__list swiper-wrapper'>
        {tabs.map((tab, index) => (
          <li
            key={tab.id}
            ref={refs.current[index]}
            className={`dln-tabs__item swiper-slide ${
              tab[activeAttribute] ? 'dln-tabs__item--current' : ''
            }`}
          >
            <button
              className='dln-tabs__btn'
              type='button'
              data-content-id={tab.id}
              onClick={() => handleClick(tab)}
              dangerouslySetInnerHTML={{ __html: t(tab.label) }}
            />
          </li>
        ))}
        <li className='dln-tabs__currentLine' style={{ ...lineStyle }} />
      </ul>
    </div>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape).isRequired,
  onClick: PropTypes.func,
  modifiers: PropTypes.arrayOf(PropTypes.string),
  activeAttribute: PropTypes.string,
  hasUpdateLine: PropTypes.bool,
};

Tabs.defaultProps = {
  onClick: null,
  modifiers: [],
  activeAttribute: 'isActive',
  hasUpdateLine: false,
};

export default Tabs;
